import React, { Component } from 'react';
import classNames from 'classnames';
import PrepareStyles from './Prepare.cssmodule.less';
import Intro from './Intro';
import ObjectsList from './ObjectsList';
import Solutions from './Solutions';

class CurriculumPrepare extends Component {
    renderContent() {
        const { subIndex = 0 } = this.props.data;
        const { doneProject = null, textContent = '', contents = {} } = this.props.data;
        switch (subIndex) {
            case 0:
                return <Intro doneProject={doneProject} question={textContent}/>;
            case 1:
                return <ObjectsList contents={contents}/>;
            case 2:
                return <Solutions contents={contents}/>;
            default:
                return '';
        }
    }

    render() {
        const { subIndex = 0 } = this.props.data;
        return <div className={classNames(PrepareStyles.curriculum, PrepareStyles[`prepare_step${subIndex + 1}`])}>
            {this.renderContent()}
        </div>;
    }
}

export default CurriculumPrepare;



// WEBPACK FOOTER //
// ./components/Curriculum/Prepare/index.js